// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tDYy","content":"styles_content__1ZEik"};